module.exports = __webpack_public_path__ + "img/samoa.d80fc4d3.png";